import * as React from 'react'

export type UseStepperParams = {
	initialStep?: number
	stepAmount: number
}

export type StepperReturn = ReturnType<typeof useStepper>

export function useStepper({ initialStep = 1, stepAmount }: UseStepperParams) {
	const [activeStep, setActiveStep] = React.useState(initialStep)

	const isFirstStep = activeStep === 1

	const isLastStep = activeStep === stepAmount

	const nextStep = () => {
		if (!isLastStep) {
			setActiveStep((prev) => prev + 1)
		}
	}

	const prevStep = () => {
		if (!isFirstStep) {
			setActiveStep((prev) => prev - 1)
		}
	}

	const resetSteps = () => {
		setActiveStep(initialStep)
	}

	return {
		stepAmount,
		nextStep,
		prevStep,
		resetSteps,
		activeStep,
		isFirstStep,
		isLastStep,
	}
}
